import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import React, { useMemo } from "react";

const StockSearch = ({ onSelect, selectedOption, location }) => {
    const {t} = useTranslation();
    const filterOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 1) return [];

        try {
            const res = await instance.get(`safety/get-inventory?q=10`, {
                params: {name: inputValue, location: location}
            });
            return res.data.map((stock) => ({
                value: stock.id,
                label: `${stock.part.sku} - ${stock.part.name} (${stock.quantity})`,
                quantity: stock.quantity
            }));
        } catch (err) {
            console.error("Failed to fetch parts: ", err);
            return [];
        }
    };

    // Debounce filterOptions and return a wrapped function that resolves a Promise
  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000); // 500ms debounce

    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
        cacheOptions
        defaultOptions={false}
        loadingMessage={() => t("general.loading")}
        loadOptions={debouncedLoadOptions}
        onChange={(option) => onSelect(option)}
        placeholder={t("forms.type.vehicle.search.visitor.search")}
        noOptionsMessage={() => t("forms.type.vehicle.search.visitor.not-found")}
        isClearable
        className="search-select"
        styles={customStyles}
        unstyled={true}
        value={selectedOption}
        required
    />
  )
}

export default React.memo(StockSearch);